import { type } from "arktype";

export const SignInFormSchema = type({
  email: "string.email",
  password: "string >= 8 | undefined", // undefined when in magic link mode
  keepMeSignedInFor30Days: "boolean?",
});

export type SignInFormValues = typeof SignInFormSchema.infer;

export const defaultSignInFormValues: SignInFormValues = {
  email: "",
  password: "",
  keepMeSignedInFor30Days: false,
};
